<template>
  <b-dropdown
    @show="onDropdownOpen()"
    @hide="onDropdownClose()"
    toggle-class="customDropdown"
    right
    :disabled="disabled"
    class="dropdown-component"
    :class="[className, { 'remove-padding': !isCaretVisible }]"
    no-caret
    :ref="uniqueReferenceId"
  >
    <template #button-content>
      <slot name="selectFilter"></slot>
      <slot name="iconContainer"></slot>
      <span
        v-if="isCaretVisible"
        class="dropdown-toggle-icon"
        :class="{ rotate: isDropdownOpen }"
        ><i class="fa fa-chevron-down"></i
      ></span>
    </template>
    <slot name="optionData"></slot>
  </b-dropdown>
</template>

<script>
export default {
  name: 'GeneralDropdown',
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: null,
    },
    isCaretVisible: {
      type: Boolean,
      default: true,
    },
    uniqueId: {
      type: String,
      default: null,
    },
    uniqueReferenceId: {
      type: String,
      default: null,
    },
  },
  methods: {
    onDropdownOpen() {
      this.isDropdownOpen = true;
      if (this.uniqueId) this.$emit('toggleListViewZIndex', this.uniqueId);
      this.$emit('onDropdownOpen');
    },
    onDropdownClose() {
      this.isDropdownOpen = false;
    },
    hideDropdown(uniqueDropdownRef) {
      const dropdownRef = this.$refs[uniqueDropdownRef];
      if (dropdownRef) {
        // Use the hide() method provided by Bootstrap-Vue to hide the dropdown
        dropdownRef.hide();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .dropdown-menu {
  background: #fff;
  width: auto;
  min-width: 130px;
  -webkit-box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  padding: 0;
  box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  border: solid 0.1px #f0f0f0;
  max-height: 300px;
  overflow: auto;
  z-index: 9;
}

::v-deep .dropdown-menu li a {
  font-size: 14px;
  background: #fff;
  padding: 10px;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  text-indent: unset;
}
::v-deep .dropdown-menu li:first-child {
  border-radius: 0.375rem 0.375rem 0 0;
}
::v-deep .dropdown-menu li:last-child {
  border-radius: 0 0 0.375rem 0.375rem;
}

::v-deep .dropdown-menu li {
  padding: 0;
  background: transparent !important;
  color: inherit !important;
  margin-left: 0;
}

::v-deep .dropdown-menu li:hover a {
  background: #f0f0f0;
  color: #212529;
}
::v-deep .customDropdown {
  background: transparent;
  color: #000;
  border: transparent;
  white-space: unset;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
}

::v-deep .customDropdown:hover,
::v-deep .customDropdown:focus {
  background: transparent !important;
  color: #000 !important;
}
::v-deep .dropdown-toggle::after {
  content: none;
}
.filter-dropdown ::v-deep .customDropdown {
  width: 119px;
  min-height: 26px;
  word-break: break-all;
  padding-right: 15px;
}
.filter-dropdown ::v-deep .dropdown-toggle::after {
  /* content: '\f078'; */
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  border: none;
  margin: 0;
  font-size: 12px;
}
.filter-dropdown ::v-deep .line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.dropdown-toggle-icon {
  transition: all 300ms ease-in-out;
  display: inline-block;
  padding: 0 8px;
  position: relative;
  top: 1px;
}
.dropdown-toggle-icon.rotate {
  top: -1px;
}
.rotate {
  transform: rotate(180deg);
}
.customDropdown.dropdown-toggle {
  display: flex;
  align-items: center;
}
.filter-dropdown ::v-deep .line-clamp {
  width: calc(100% - 28px);
}
.remove-padding ::v-deep .customDropdown {
  padding: 0;
}
</style>
